module.exports = __webpack_public_path__ + "static/media/20210307_004517502_iOS.e5ef8f26.jpg";